const CockpitOffcanvasTypes = {
  ORDER_DETAILS: 'order-details',
  QUEUE_ITEM_DETAILS: 'queue-item-details',
  QUEUE_ITEM_OPERATIONS: 'queue-item-operations',
  QUEUE_ITEM_AUDIT: 'queue-item-audit',
  PRINT_MANUALLY: 'print-manually',
};

export default CockpitOffcanvasTypes;
